// Workbench store module
import workflow from './workflow';
import providers from './providers';
import formBuilder from './formBuilder';

export default {
  namespaced: true,
  
  state: {
    // Current selected section in sidebar
    currentSection: 'ez-bill', // 'workflow', 'template', 'settings', etc.
    // Sidebar collapsed state
    isSidebarCollapsed: false,
  },
  
  getters: {
    getCurrentSection: (state) => state.currentSection,
    getIsSidebarCollapsed: (state) => state.isSidebarCollapsed,
  },
  
  mutations: {
    SET_CURRENT_SECTION(state, section) {
      state.currentSection = section;
    },
    
    SET_SIDEBAR_COLLAPSED(state, collapsed) {
      state.isSidebarCollapsed = collapsed;
    },
    
    TOGGLE_SIDEBAR(state) {
      state.isSidebarCollapsed = !state.isSidebarCollapsed;
    },
  },
  
  actions: {
    setCurrentSection({ commit }, section) {
      commit('SET_CURRENT_SECTION', section);
    },
    
    setSidebarCollapsed({ commit }, collapsed) {
      commit('SET_SIDEBAR_COLLAPSED', collapsed);
    },
    
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR');
    },
  },
  
  modules: {
    workflow,
    providers,
    formBuilder
  }
};
